<template>
  <!-- eslint-disable -->
  <div style="text-align:left; background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); min-height: 100vh;">
    
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNav />
      <div class="main-container">   
        
        <div v-show="loaded" class="articulo-principal">
          <!-- Header Section -->
          <div class="profile-header">
            <div class="header-content">
              <div class="header-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="currentColor"/>
                  <path d="M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16.4183 14 12 14Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="header-text">
                <h1>Perfil del Administrador</h1>
                <p>Información personal y configuración de la cuenta</p>
              </div>
            </div>
          </div>

          <!-- Info Banner -->
          <div class="info-banner">
            <div class="banner-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor"/>
              </svg>
            </div>
            <span>Esta es una vista de solo lectura de tu perfil de administrador. Los datos se obtienen automáticamente del sistema.</span>
          </div>

          <!-- Profile Content -->
          <div class="profile-content">
            
            <!-- Personal Information Card -->
            <div class="profile-card">
              <div class="card-header">
                <div class="card-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="currentColor"/>
                    <path d="M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16.4183 14 12 14Z" fill="currentColor"/>
                  </svg>
                </div>
                <h3>Información Personal</h3>
              </div>
              <div class="card-content">
                <div class="info-grid">
                  <div class="info-item">
                    <label>Nombre Completo</label>
                    <div class="info-value">
                      <span v-if="adminData">{{ adminData.nombre }} {{ adminData.apellido }}</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Email</label>
                    <div class="info-value">
                      <span v-if="adminData">{{ adminData.email }}</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>ID de Usuario</label>
                    <div class="info-value">
                      <span v-if="adminData">#{{ adminData.id }}</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Teléfono</label>
                    <div class="info-value">
                      <span v-if="adminData && adminData.telefono">{{ adminData.telefono }}</span>
                      <span v-else-if="adminData">No especificado</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Provider Information Card -->
            <div class="profile-card">
              <div class="card-header">
                <div class="card-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
                    <path d="M7 7H17V9H7V7ZM7 11H17V13H7V11ZM7 15H13V17H7V15Z" fill="currentColor"/>
                  </svg>
                </div>
                <h3>Información del Prestador</h3>
              </div>
              <div class="card-content">
                <div class="info-grid">
                  <div class="info-item">
                    <label>Nombre del Prestador</label>
                    <div class="info-value">
                      <span v-if="prestador">{{ prestador.nombre }}</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>ID del Prestador</label>
                    <div class="info-value">
                      <span v-if="prestador">#{{ prestador.id }}</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Tipo de Prestador</label>
                    <div class="info-value">
                      <span v-if="prestador && prestador.tipo">{{ prestador.tipo }}</span>
                      <span v-else-if="prestador">No especificado</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Estado</label>
                    <div class="info-value">
                      <span v-if="prestador" class="status-badge status-active">Activo</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Account Settings Card -->
            <div class="profile-card">
              <div class="card-header">
                <div class="card-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.82,11.69,4.82,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" fill="currentColor"/>
                  </svg>
                </div>
                <h3>Configuración de la Cuenta</h3>
              </div>
              <div class="card-content">
                <div class="info-grid">
                  <div class="info-item">
                    <label>Fecha de Creación</label>
                    <div class="info-value">
                      <span v-if="adminData && adminData.created_at">{{ formatDate(adminData.created_at) }}</span>
                      <span v-else-if="adminData">No disponible</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Último Acceso</label>
                    <div class="info-value">
                      <span v-if="adminData && adminData.last_login">{{ formatDate(adminData.last_login) }}</span>
                      <span v-else-if="adminData">No disponible</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Rol</label>
                    <div class="info-value">
                      <span v-if="adminData" class="role-badge">Administrador</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Permisos</label>
                    <div class="info-value">
                      <span v-if="adminData" class="permission-badge">Acceso Completo</span>
                      <span v-else class="loading-text">Cargando...</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mobile View Cards -->
            <div class="mobile-cards">
              <!-- Personal Info Mobile -->
              <div class="mobile-card">
                <div class="mobile-card-header">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="currentColor"/>
                    <path d="M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16.4183 14 12 14Z" fill="currentColor"/>
                  </svg>
                  <h4>Información Personal</h4>
                </div>
                <div class="mobile-card-content">
                  <div class="mobile-info-item">
                    <span class="mobile-label">Nombre:</span>
                    <span class="mobile-value" v-if="adminData">{{ adminData.nombre }} {{ adminData.apellido }}</span>
                    <span class="mobile-value loading-text" v-else>Cargando...</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">Email:</span>
                    <span class="mobile-value" v-if="adminData">{{ adminData.email }}</span>
                    <span class="mobile-value loading-text" v-else>Cargando...</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">ID:</span>
                    <span class="mobile-value" v-if="adminData">#{{ adminData.id }}</span>
                    <span class="mobile-value loading-text" v-else>Cargando...</span>
                  </div>
                </div>
              </div>

              <!-- Provider Info Mobile -->
              <div class="mobile-card">
                <div class="mobile-card-header">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
                    <path d="M7 7H17V9H7V7ZM7 11H17V13H7V11ZM7 15H13V17H7V15Z" fill="currentColor"/>
                  </svg>
                  <h4>Prestador</h4>
                </div>
                <div class="mobile-card-content">
                  <div class="mobile-info-item">
                    <span class="mobile-label">Nombre:</span>
                    <span class="mobile-value" v-if="prestador">{{ prestador.nombre }}</span>
                    <span class="mobile-value loading-text" v-else>Cargando...</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">ID:</span>
                    <span class="mobile-value" v-if="prestador">#{{ prestador.id }}</span>
                    <span class="mobile-value loading-text" v-else>Cargando...</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">Estado:</span>
                    <span class="mobile-value" v-if="prestador">
                      <span class="status-badge status-active">Activo</span>
                    </span>
                    <span class="mobile-value loading-text" v-else>Cargando...</span>
                  </div>
                </div>
              </div>

              <!-- Account Settings Mobile -->
              <div class="mobile-card">
                <div class="mobile-card-header">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.82,11.69,4.82,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" fill="currentColor"/>
                  </svg>
                  <h4>Configuración</h4>
                </div>
                <div class="mobile-card-content">
                  <div class="mobile-info-item">
                    <span class="mobile-label">Rol:</span>
                    <span class="mobile-value" v-if="adminData">
                      <span class="role-badge">Administrador</span>
                    </span>
                    <span class="mobile-value loading-text" v-else>Cargando...</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">Permisos:</span>
                    <span class="mobile-value" v-if="adminData">
                      <span class="permission-badge">Acceso Completo</span>
                    </span>
                    <span class="mobile-value loading-text" v-else>Cargando...</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-show="!loaded" class="articulo-principal">
          <div style="height: calc(100vh - 140px); display: flex; justify-content: center; align-items: center;">
            <Loader :height="100" :width="100" />
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';

export default {
  name: 'AdminProfile',
  props:['id'],
  components: {
    SideNav,
    Loader,
    TopNav,
  },
  data() {
    return {
      loaded: false,
      adminData: null,
    }
  },
  created(){
    this.getAdminData();
  },
  methods:{
    ...mapActions(['initialize']),
    
    async getAdminData(){
      try {
        const response = await axios.get(window.hostname + '/api/admin/getadminbytoken');
        this.adminData = response.data;
        this.loaded = true;
      } catch (error) {
        console.error('Error fetching admin data:', error);
        this.loaded = true;
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'No disponible';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return 'Fecha inválida';
      }
    }
  },
  computed:{
    ...mapGetters(['comunas', 'categorias', 'regiones', 'prestaciones', 'tipos', 'admin_datos', 'prestador']),
  },
}
</script>

<style scoped>
/* Base Layout */
.column-left {
  position: fixed;
  left: 0;
  top: 0;
  width: 260px;
  height: 100vh;
  z-index: 1000;
  transition: transform 0.3s ease;
}

.column-right {
  margin-left: 260px;
  min-height: 100vh;
  transition: margin-left 0.3s ease;
}

.main-container {
  padding: 0;
  max-width: 100%;
}

.articulo-principal {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px;
  background: transparent;
}

/* Header Section */
.profile-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
}

.header-text h1 {
  margin: 0 0 8px 0;
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.2;
}

.header-text p {
  margin: 0;
  font-size: 16px;
  color: #64748b;
  font-weight: 400;
}

/* Info Banner */
.info-banner {
  background: linear-gradient(135deg, #e0f2fe 0%, #b3e5fc 100%);
  border: 1px solid #81d4fa;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #0277bd;
}

.banner-icon {
  color: #0288d1;
  flex-shrink: 0;
}

/* Profile Content */
.profile-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

/* Profile Cards */
.profile-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.profile-card:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
}

.card-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
}

.card-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1a202c;
}

.card-content {
  padding: 24px;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-item label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 16px;
  font-weight: 500;
  color: #1a202c;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  min-height: 20px;
  display: flex;
  align-items: center;
}

.loading-text {
  color: #94a3b8;
  font-style: italic;
}

/* Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-active {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  color: #166534;
  border: 1px solid #86efac;
}

.role-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%);
  color: #5b21b6;
  border: 1px solid #a78bfa;
}

.permission-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
  border: 1px solid #fbbf24;
}

/* Mobile Cards - Hidden by default */
.mobile-cards {
  display: none;
}

.mobile-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  margin-bottom: 16px;
  overflow: hidden;
}

.mobile-card-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-card-header svg {
  color: #667eea;
}

.mobile-card-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
}

.mobile-card-content {
  padding: 20px;
}

.mobile-info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

.mobile-info-item:last-child {
  border-bottom: none;
}

.mobile-label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}

.mobile-value {
  font-size: 14px;
  font-weight: 500;
  color: #1a202c;
  text-align: right;
}

/* Responsive Design */
@media (max-width: 768px) {
  .column-left {
    transform: translateX(-100%);
  }

  .column-right {
    margin-left: 0;
  }

  .articulo-principal {
    padding: 20px 16px;
  }

  .profile-header {
    padding: 24px 20px;
  }

  .header-content {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .header-icon {
    width: 56px;
    height: 56px;
  }

  .header-text h1 {
    font-size: 24px;
  }

  .header-text p {
    font-size: 14px;
  }

  .info-banner {
    padding: 14px 16px;
    font-size: 13px;
  }

  /* Hide desktop cards, show mobile cards */
  .profile-card {
    display: none;
  }

  .mobile-cards {
    display: block;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .articulo-principal {
    padding: 16px 12px;
  }

  .profile-header {
    padding: 20px 16px;
  }

  .header-icon {
    width: 48px;
    height: 48px;
  }

  .header-text h1 {
    font-size: 20px;
  }

  .mobile-card-content {
    padding: 16px;
  }

  .mobile-info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .mobile-value {
    text-align: left;
  }
}

/* Sidebar responsive behavior */
@media (max-width: 1024px) {
  .column-left {
    transform: translateX(-100%);
  }

  .column-right {
    margin-left: 0;
  }
}

/* Animation for loading states */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.loading-text {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>